import { SignIn } from "@clerk/react-router";
import { CircleCheck, ShieldCheck } from "lucide-react";

export default function SignInPage() {
  return (
    <div className="grid min-h-[70vh] items-center gap-6 lg:grid-cols-[1.1fr_1fr]">
      <div className="brand-shell-card brand-surface-gradient p-8 sm:p-10">
        <div className="brand-kicker">welcome back</div>
        <div className="mt-3 text-4xl font-semibold tracking-tight text-[#431908] sm:text-5xl">
          rb2 service desk
        </div>
        <p className="brand-subtle-text mt-4 max-w-xl text-base">
          Built for rb2 client teams that need calm, clear, and reliable
          incident communication.
        </p>

        <div className="mt-8 space-y-3">
          <div className="brand-soft-panel flex items-center gap-3 px-4 py-3">
            <ShieldCheck className="h-4 w-4 text-[#fe150a]" />
            <span className="text-sm text-[#431908]">
              Secure access through rb2 identity controls
            </span>
          </div>
          <div className="brand-soft-panel flex items-center gap-3 px-4 py-3">
            <CircleCheck className="h-4 w-4 text-[#fe150a]" />
            <span className="text-sm text-[#431908]">
              Raise incidents in seconds with guided severity
            </span>
          </div>
        </div>
      </div>

      <div className="flex justify-center px-2 py-8 sm:px-4">
        <SignIn
          appearance={{
            elements: {
              rootBox: "w-full flex justify-center",
              card: "border border-[#efe8e5] shadow-[0_8px_28px_rgba(51,13,1,0.08)] rounded-[16px] bg-white/95",
              headerTitle: "text-[#431908] text-xl font-semibold",
              headerSubtitle: "text-[#431908]/70",
              socialButtonsBlockButton:
                "border border-[#efe8e5] hover:bg-[#fff8f6] text-[#431908]",
              formFieldInput:
                "border border-[#efe8e5] focus:border-[#fe150a] focus:ring-[#fe150a]/20 rounded-[10px]",
              formButtonPrimary:
                "rounded-[10px] bg-[#fe150a] hover:bg-[#e31700] text-white shadow-sm",
              footerActionLink: "text-[#fe150a] hover:text-[#e31700]",
            },
          }}
        />
      </div>
    </div>
  );
}
